module.exports = __webpack_public_path__ + "img/resources5.ca97c0e8.jpg";